module.exports = __webpack_public_path__ + "media/images/pages/about_us/team_members/thomas-3c010ea28ee9105533310a03929a2fc8.png";